import React, { FC, useEffect, useState } from "react";
import classes from "./Results.module.scss";
import {
  Dirary,
  WorkerForMatrix,
  summaryByProductNo,
  summaryByWorker,
} from "../../../types/dirary";
import SelectBoxForString from "../../uikit/atoms/selectboxes/SelectBoxForString";
import { userState } from "../../../states/userState";
import { useRecoilState, useRecoilValue } from "recoil";
import { User } from "../../../types";
import { diaryListStateForMatrix } from "../../../states/diaryListState";
import { calendarListStateForMatrix } from "../../../states/calendarListState";
import { processListStateForMatrix } from "../../../states/processListState";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import {
  gatherDairyListAsProductNoAndDisplayName,
  gatherDairyListAsWorkerAndProductNoAndDisplayName,
} from "../../../utils/functions/summary";
import TableMain from "../../diaryList/displayArea/table/TableMain";
import TableMainForMatrix from "../table/TableMainForMatrix";
import { zoomState } from "../../../states/zoomState";
type Props = {
  productNo: string;
  setProductNo: React.Dispatch<React.SetStateAction<string>>;
  productBno: string;
  setProductBno: React.Dispatch<React.SetStateAction<string>>;
};

const Results: FC<Props> = (props) => {
  const { productNo, setProductNo, productBno, setProductBno } = props;
  const [user, setUser] = useRecoilState<User>(userState);
  const diaryList = useRecoilValue(diaryListStateForMatrix);
  const [filteredDiaeyList, setFilteredDiaryList] = useState<Dirary[]>([]);
  const calendar = useRecoilValue(calendarListStateForMatrix);
  const processList = useRecoilValue(processListStateForMatrix);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isIphone = useMediaQuery(theme.breakpoints.down("sm"));
  const isNotePc = useMediaQuery(theme.breakpoints.down("xl"));
  const zoomLevel = useRecoilValue(zoomState);
  const zoom = parseFloat(zoomLevel) || 1;
  const [summaryAsWorker, setSummaryAsWorker] = useState<summaryByWorker[]>([]);
  const [summaryAsProductNo, setSummaryAsProductNo] = useState<
    summaryByProductNo[]
  >([]);
  useEffect(() => {
    setFilteredDiaryList(
      diaryList.filter(
        (diary) =>
          diary.productNo === productNo && diary.productBno === productBno
      )
    );
  }, [diaryList, productNo, productBno]);
  useEffect(() => {
    const resultAsWorker =
      gatherDairyListAsWorkerAndProductNoAndDisplayName(filteredDiaeyList);
    setSummaryAsWorker(resultAsWorker);
    const resultAsProductNo =
      gatherDairyListAsProductNoAndDisplayName(resultAsWorker);
    setSummaryAsProductNo(resultAsProductNo);
  }, [filteredDiaeyList]);
  useEffect(() => {
    console.log("summary", summaryAsProductNo, summaryAsWorker);
  }, [summaryAsProductNo, summaryAsWorker]);

  //   //社員番号の初期値を設定
  //   const [workerId, setWorkerId] = useState<string>(
  //     user.initialParameters.wokerIdForMatrix ?? ""
  //   );
  //   useEffect(() => {
  //     if (workerList.length > 0) {
  //       if (workerId === "") {
  //         setWorkerId(workerList[0].id);
  //       } else {
  //         const worker = workerList.find((worker) => worker.id === workerId);
  //         if (worker === undefined) {
  //           setWorkerId(workerList[0].id);
  //         }
  //       }
  //     }
  //   }, [workerList]);
  //   const handleWorkerChange = (e: string) => {
  //     setWorkerId(e);
  //   };
  return (
    <Box
      sx={{
        display: "flex",
        paddingTop: "5px",
        gap: "10px",
        flexDirection: "column",
        overflowY: "auto",
        maxHeight: `${
          isIphone
            ? `calc((100vh - 220px * ${zoom}) / ${zoom})`
            : isNotePc
            ? `calc((100vh - 120px * ${zoom}) / ${zoom})`
            : `calc((100vh - 120px * ${zoom}) / ${zoom})`
        }`,
        // flexGrow: 1,
      }}
    >
      {summaryAsProductNo.length > 0 && setSummaryAsWorker.length > 0 && (
        <div className={classes.rootContainer}>
          {/* <div className={classes.result}>
            <div>
              <p>作業者</p>
              <div className={classes.select}>
                <SelectBoxForString
                  label={""}
                  options={workerList}
                  required={true}
                  select={handleWorkerChange}
                  value={workerId}
                  disabled={false}
                  width={"140px"}
                  height={"32px"}
                  fontSize={"12px"}
                  setMode={"input"}
                  colorMode={"dark"}
                />
              </div>
            </div>
            <div>
              <p>作業時間</p>
              <p>
                {`${
                  summaryAsWorker[0].totalWorkingTimeText
                } （${summaryAsWorker[0].totalWorkingTimeByHour.toFixed(1)}）`}
              </p>
            </div>
            <div>
              <p>現場名</p>
              <p>{summaryAsProductNo[0].siteName}</p>
            </div>
          </div> */}
          <div className={classes.table}>
            {summaryAsProductNo.map((productSummary, productIndex) =>
              summaryAsWorker
                .filter(
                  (workerSummary) =>
                    // workerSummary.constructionId ===
                    //   productSummary.constructionId &&
                    workerSummary.productNo === productSummary.productNo &&
                    workerSummary.productBno === productSummary.productBno &&
                    workerSummary.siteName === productSummary.siteName &&
                    workerSummary.workerId ===
                      user.initialParameters.wokerIdForMatrix
                )
                .map((workerSummary, workerIndex) => (
                  <TableMainForMatrix
                    key={workerIndex}
                    calendar={calendar}
                    processList={processList}
                    diaryList={filteredDiaeyList}
                    summaryByWorker={workerSummary}
                    summaryByProductNo={productSummary}
                  />
                ))
            )}
          </div>
        </div>
      )}
    </Box>
  );
};

export default Results;
